// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__1DW6f","active":"downloadDropdown_active__SxgNQ"};